export default "__VITE_ASSET__700ce320__"